<template>
<div>
  <CenterizedTile @click="dialog=true">
    <IconifiedTile>
      <template #icon>
        <v-icon size="60" :color="displayColor">{{ power ? 'mdi-lightbulb' : 'mdi-lightbulb-off' }}</v-icon>
      </template>
      <template #value>{{ brightness || '---' }}</template>
      <template #unit>%</template>
      <template #title>{{ config.name || $t(`type.${info.type}`) }}</template>
    </IconifiedTile>
  </CenterizedTile>
  <LightControlDialog v-model="dialog" :power.sync="power" :brightness.sync="brightness" :color.sync="color" :colorSetting="info.traits.includes('ColorSetting')" @setting="showSettingsDialog"></LightControlDialog>
</div>
</template>

<script>
import EndpointTile from '@/components/tile/EndpointTile'
import CenterizedTile from '@/components/tile/CenterizedTile'
import IconifiedTile from '@/components/tile/IconifiedTile'
import LightControlDialog from '@/components/dialog/LightControlDialog'

export default {
  name: 'LightTile',
  mixins: [EndpointTile],
  components: {
    LightControlDialog,
    CenterizedTile,
    IconifiedTile
  },
  computed: {
    power: {
      get() {
        return this.report.on;
      },
      set(val) {
        if (this.report.on != val) {
          this.$set(this.report, 'on', val);
          this.$emit('command', {
            [this.endpointId]: {
              on: val
            }
          });
        }
      }
    },
    brightness: {
      get() {
        return this.report.brightness;
      },
      set(val) {
        if (this.report.brightness != val) {
          this.$set(this.report, 'brightness', val);
          this.$emit('command', {
            [this.endpointId]: {
              brightness: val
            }
          });
        }
      }
    },
    displayColor() {
      let c = this.report.color;
      if (c) {
        return `hsl(${c.hue},${c.saturation*100}%,${this.brightness*0.6+20}%)`;
      }
      if (this.power) {
        return 'primary';
      }
      return 'grey';
    },
    color: {
      get() {
        let c = this.report.color;
        if (c) return {
          h: c.hue,
          s: c.saturation * 100,
          v: this.brightness,
          a: 1
        }
        else return {
          h: 100,
          s: 100,
          v: 50,
          a: 1
        }
      },
      set(val) {
        let c = {
          hue: val.h,
          saturation: val.s / 100,
          value: val.v / 100
        };
        if (JSON.stringify(c) != JSON.stringify(this.report.color)) {
          this.$emit('command', {
            [this.endpointId]: {
              color: c
            }
          });
        }
      }
    }
  }
}
</script>
